<template>
    <c-main>

    <c-row>
        <c-col md="12">
            <c-panel title="User settings">
                <form @submit.prevent="usersettingsValidate">
                    <c-form-field label="Name*">
                        <c-form-input v-bind:autocomplete="'name'" v-bind:status="$v.usersettings.name.$error ? 'danger' : ''" v-model="usersettings.name"></c-form-input>
                        <span v-if="usersettings.submitted && !$v.usersettings.name.required" class="form-help u-color-danger">Name is required.</span>
                    </c-form-field>

                    <c-form-field label="Email*">
                        <c-form-input v-bind:autocomplete="'email'" v-bind:status="$v.usersettings.email.$error ? 'danger' : ''" v-model="usersettings.email"></c-form-input>
                        <span v-if="usersettings.submitted && !$v.usersettings.email.required" class="form-help u-color-danger">Email is required.</span>
                        <span v-if="usersettings.submitted && !$v.usersettings.email.email" class="form-help u-color-danger">Email is invalid.</span>

                    </c-form-field>

                    <c-form-field label="Date of birth">
                        <c-flatpickr placeholder="Select Date..." v-model="usersettings.birthday" />
                    </c-form-field>

                    <div class="u-text-right" slot="footer">
                        <c-button type="primary" smart>Save</c-button>
                    </div>
                </form>
            </c-panel>
        </c-col>
        <c-col md="12">
                <c-panel title="Change Password ">
                    
                    <form @submit.prevent="passwordChangeValidate">
                        <c-form-field label="New password">
                            <c-form-input type="password"></c-form-input>
                        </c-form-field>

                        <c-form-field label="Repeat password">
                            <c-form-input type="password"></c-form-input>
                        </c-form-field>

                        <div class="u-text-right" slot="footer">
                            <c-button type="primary" smart>Save</c-button>
                        </div>
                    </form>

                </c-panel>
        </c-col>
    </c-row>
    </c-main>
</template>

<script>
import FlatPickr from 'cover/vendors/flatpickr';
import { required, email, minLength } from "vuelidate/lib/validators";


export default {
    components: {
        [FlatPickr.name]: FlatPickr
    },
    data(){
        return {
            usersettings: {
                name: '',
                email: '',
                birthday: '',
                submitted: false
            }
        }
    },
    validations: {
        usersettings: {
            name: { required },
            email: { required, email }
        }

    },
    methods: {
        usersettingsValidate: function() {

            let _this = this;
            this.usersettings.submitted = true;
            this.$v.usersettings.$touch();

            // if its still pending or an error is returned do not submit
            if (this.$v.usersettings.$pending || this.$v.usersettings.$error) return;

            this.$toast.succeed('Data saved!', 2000)

        },
        passwordChangeValidate: function() {

            console.log('passwordchange');

        }
    }
}
</script>